export const LOCAL_STORAGE_KEYS = Object.freeze({
    MATCHING_STORAGE: 'matchingStorage'
})
